import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=0554d8be&scoped=true&"
import script from "./ProductModal.vue?vue&type=script&lang=js&"
export * from "./ProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductModal.vue?vue&type=style&index=0&id=0554d8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554d8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\gift-of-choice\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0554d8be')) {
      api.createRecord('0554d8be', component.options)
    } else {
      api.reload('0554d8be', component.options)
    }
    module.hot.accept("./ProductModal.vue?vue&type=template&id=0554d8be&scoped=true&", function () {
      api.rerender('0554d8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "GiftOfChoice/components/ProductModal.vue"
export default component.exports